<template>
  <intersection-observer
    class="event-video-observer-container"
    :observe-from-bottom="true"
    :observe-view-height="100"
    @element-in-view="handleElementInView"
  >
    <div :class="videoClass" class="video-iframe-container">
      <iframe
        v-if="isVisible"
        :src="videoUrl"
        class="video-iframe"
        title="Video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
        v-bind="isTikTok ? { scrolling: 'no' } : {}"
      ></iframe>
      <div v-else class="loading-placeholder">
        <icon :pulse="true" fas="fa-spinner" />
      </div>
    </div>
  </intersection-observer>
</template>

<script setup lang="ts">
type PlatformType = 'youtube' | 'tiktok'

const props = defineProps({
  videoUrl: { type: String, default: '', required: true },
  videoAspectRatio: { type: Object, default: () => ({ width: 16, height: 9 }), required: true },
  platformType: { type: String, default: 'youtube' as PlatformType }
})

const isVisible = ref(false)

const isTikTok = computed(() => props.platformType === 'tiktok')
const videoClass = computed(() => {
  const { width, height } = props.videoAspectRatio
  const aspectRatio = width < height ? 'nine_sixteen' : 'sixteen_nine'

  return {
    [aspectRatio]: true,
    [props.platformType]: true
  }
})

const handleElementInView = () => {
  isVisible.value = true
}
</script>

<style scoped lang="scss">
.event-video-observer-container {
  @include flex;
  width: 100%;
  height: 100%;
}

.video-iframe-container {
  @include flex;
  position: relative;
  max-height: 462px;

  &.sixteen_nine {
    width: 100%;
    aspect-ratio: 16 / 9;
  }

  &.nine_sixteen {
    width: 240px;
    aspect-ratio: 9 / 16;
    margin: 0 auto;
    &.tiktok {
      width: 136%;
      max-width: 136%;
      height: 766px;
      max-height: 766px;
      margin: -100px auto;
      scale: 0.7384;
    }
  }
}

.video-iframe {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.loading-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
}
</style>
